import '../styles/banner.scss'
import '../styles/lower-footer.scss'
import { type FC, Fragment } from 'react'
import { Link } from 'react-router-dom'
import { cmsDataService } from '@/common/services/cms.data.service'

export const LowerFooter: FC = () => {
    const lowerFooter = cmsDataService.get().footer.lowerFooter
    if (!lowerFooter) return null

    return (
        <span className="lower-footer container-lg-padding">
            <div className="lower-footer__note">
                <h6 className="lower-footer__note--title">{lowerFooter.noteTitle}</h6>
                <p className="lower-footer__note--description">{lowerFooter.noteDescription}</p>
            </div>
            <span className="lower-footer__info">
                {lowerFooter.textAndLinks.map((textOrLink, index) => {
                    if ('text' in textOrLink && textOrLink.text) return <p key={index}>{textOrLink.text}</p>

                    if ('link' in textOrLink && textOrLink.link) {
                        const { url, name, ...rest } = textOrLink.link
                        return <Link {...rest} key={index} to={url} children={name} />
                    }
                })}
            </span>
        </span>
    )
}
